class CartHelper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.cartBuildHandler = this.refreshCountdown.bind(this);
    this.cartOpenHandler = this.refreshCountdown.bind(this);
    this.cartUpdatedHandler = this.refreshCountdown.bind(this);
    this.cartAjaxProductAddHandler = this.refreshCountdown.bind(this);

    document.addEventListener('ajaxProduct:added', this.cartAjaxProductAddHandler);
    document.addEventListener('cart:updated', this.cartUpdatedHandler);
    window.addEventListener('cart:open', this.cartOpenHandler);
    document.addEventListener('cart:build', this.cartBuildHandler);
  }
  disconnectedCallback() {
    document.removeEventListener('ajaxProduct:added', this.cartAjaxProductAddHandler);
    document.removeEventListener('cart:updated', this.cartUpdatedHandler);
    window.removeEventListener('cart:open', this.cartOpenHandler);
    document.removeEventListener('cart:build', this.cartBuildHandler);
  }
  refreshCountdown(){
    fetch(window.location.pathname + `?sections=${this.sectionId}`, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then((response) => response.json())
    .then((data) => {
      const template = document.createElement('template');
      template.innerHTML = data[`${this.sectionId}`];
      const oldCountdown = document.querySelector('.countdown__block');
      const newCountdown = template.content.querySelector('.countdown__block');
      if(!!oldCountdown && !!newCountdown){
        oldCountdown.replaceWith(newCountdown);
        this.reEvaluateScripts();
      }
    });
  }

  reEvaluateScripts(){
    let section = document.querySelector(`#shopify-section-${this.sectionId}`)
    section.querySelectorAll('script').forEach(script => {
        let newScript = document.createElement('script');
        newScript.innerHTML = script.innerHTML;
        Array.from(script.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
        script.replaceWith(newScript)
    })
  }

}
customElements.define("cart-helper", CartHelper);

(function () {
  if (!window.theme || !theme.cart || !theme.cart.getCartProductMarkup || window.Shopify.designMode) return;
  const dealPage = document.querySelector('[data-tdt-deal-code="aktion40"]');
  let code = 'aktion20';
  let dealQuantity = null;
  let dealActivated = false;
  const root = window.Shopify.routes.root;
  const originalMarkup = theme.cart.getCartProductMarkup.bind(theme.cart);
  let pending = null;
  let lastCart = null;

  function readCart() {
    return fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(response => {if (!response.ok) throw new Error('Cart unavailable'); return response.json();});
  }

  function ensureBenefit() {
    if (pending) return pending;
    pending = readCart().then(cart => {
      // Activate the deal only after this concert's cart quantity increases.
      if (dealPage) {
        const quantity = cart.items.reduce((total, item) => total + (String(item.product_id) === dealPage.dataset.tdtDealProduct ? item.quantity : 0), 0);
        if (dealQuantity !== null && quantity > dealQuantity) dealActivated = true;
        dealQuantity = quantity;
      }
      const codes = (cart.discount_codes || []).map(discount => discount.code);
      (cart.cart_level_discount_applications || []).forEach(discount => {
        if (discount.type === 'discount_code' && !codes.includes(discount.title)) codes.push(discount.title);
      });
      cart.items.forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
        const discount = allocation.discount_application;
        if (discount.type === 'discount_code' && !codes.includes(discount.title)) codes.push(discount.title);
      }));
      const applied40 = (cart.discount_codes || []).some(discount => discount.code.toLowerCase() === 'aktion40' && discount.applicable)
        || (cart.cart_level_discount_applications || []).some(discount => discount.type === 'discount_code' && discount.title.toLowerCase() === 'aktion40')
        || cart.items.some(item => (item.line_level_discount_allocations || []).some(allocation => allocation.discount_application.type === 'discount_code' && allocation.discount_application.title.toLowerCase() === 'aktion40'));
      code = dealActivated || applied40 ? 'aktion40' : 'aktion20';
      const replaceTwenty = code === 'aktion40' && codes.some(value => value.toLowerCase() === 'aktion20');
      if (codes.some(value => value.toLowerCase() === code) && !replaceTwenty) return cart;
      if (code === 'aktion40') {
        for (let i = codes.length - 1; i >= 0; i--) if (codes[i].toLowerCase() === 'aktion20') codes.splice(i, 1);
      }
      codes.push(code);
      return fetch(root + 'cart/update.js', {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json', 'Accept':'application/json'},
        body:JSON.stringify({discount:[...new Set(codes)].join(',')})
      }).then(response => {if (!response.ok) throw new Error('Discount unavailable'); return response.json();});
    }).then(cart => {lastCart = cart; return cart;}).catch(() => null).finally(() => {pending = null;});
    return pending;
  }

  function showBenefit(markup, cart) {
    if (!cart) return markup;
    let amount = 0;
    const isBenefit = discount => discount && discount.type === 'discount_code' && discount.title.toLowerCase() === code;
    (cart.cart_level_discount_applications || []).forEach(discount => {
      if (isBenefit(discount)) amount += discount.total_allocated_amount;
    });
    cart.items.forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
      if (isBenefit(allocation.discount_application)) amount += allocation.amount;
    }));
    if (amount <= 0) return markup;
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const discounts = doc.querySelector('.cart__discounts');
    if (!discounts) return markup;
    // Replace only this promotion's native row; keep unrelated discounts visible.
    discounts.querySelectorAll('.tdt-cart-benefit').forEach(row => row.remove());
    discounts.querySelectorAll('.cart__discount').forEach(row => {
      if (row.textContent.trim().toLowerCase().startsWith(code + ' (')) row.remove();
    });
    if (!discounts.querySelector('.cart__discount')) discounts.replaceChildren();
    discounts.classList.remove('hide');
    const panel = document.createElement('div');
    panel.className = 'tdt-cart-benefit';
    panel.setAttribute('role','status');
    panel.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7 12 3 3 7-7"/></svg><div><strong></strong><small></small></div><strong class="tdt-cart-benefit-amount"></strong>';
    panel.querySelector('div strong').textContent = code === 'aktion40' ? 'Deine Ersparnis (40 %)' : window.tdtTicketBenefitCopy.title;
    panel.querySelector('small').textContent = code === 'aktion40' ? 'Mit aktion40 eingelöst' : window.tdtTicketBenefitCopy.applied;
    panel.querySelector('.tdt-cart-benefit-amount').textContent = '−' + new Intl.NumberFormat(document.documentElement.lang || 'de', {style:'currency', currency:cart.currency}).format(amount / 100);
    discounts.prepend(panel);
    return doc.body.innerHTML;
  }

  theme.cart.getCartProductMarkup = function () {
    // An in-flight page-load check must finish before inspecting the added seats.
    return (pending || Promise.resolve()).then(ensureBenefit).then(() => Promise.all([originalMarkup(), readCart().catch(() => null)]))
      .then(([markup, cart]) => {if (cart) lastCart = cart; return showBenefit(markup, cart);});
  };

  const checkedForms = new WeakSet();
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('form[action$="/cart"]') || checkedForms.has(form)) return;
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (lastCart && !pending && (lastCart.discount_codes || []).some(discount => discount.code.toLowerCase() === code)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ensureBenefit().then(() => {
      if (!form.isConnected) return;
      checkedForms.add(form);
      form.requestSubmit(submitter);
      checkedForms.delete(form);
    });
  }, true);

  window.tdtReadTicketBenefit = () => (pending || Promise.resolve()).then(ensureBenefit);
  ensureBenefit();
})();

/* Keep Vivenu and the cart inside the visible viewport, without scrolling the PDP. */
(function () {
  'use strict';
  function initOverlayViewport() {
    if (document.getElementById('tdt-overlay-viewport-style')) return;
    var root = document.documentElement;
    var body = document.body;
    var state = null;
    var frame = 0;
    var closeTimer = 0;
    var seatHeight = 0, seatWidth = 0;
    var smallViewport = document.createElement('div');
    smallViewport.setAttribute('aria-hidden', 'true');
    smallViewport.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;width:0;height:100svh;contain:strict;';
    body.appendChild(smallViewport);
    var selector = '.seating-app-smmodal.active, #CartDrawer.drawer--is-open';
    var style = document.createElement('style');
    style.id = 'tdt-overlay-viewport-style';
    style.textContent = `
      html.tdt-overlay-locked { overscroll-behavior: none; }
      html.tdt-overlay-locked #CartDrawer { overscroll-behavior: contain; }
      html.tdt-overlay-locked #CartDrawer .drawer__scrollable { overscroll-behavior-y: contain; }
      @media (max-width: 769px) {
        html.tdt-overlay-locked .seating-app-smmodal.active .smmodal {
          top: var(--tdt-seat-top, 0px) !important;
          bottom: auto !important;
          height: var(--tdt-seat-height, 100svh) !important;
          max-height: var(--tdt-seat-height, 100svh) !important;
          overflow: hidden;
        }
        html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-content {
          top: 0 !important;
          transform: none !important;
          height: 100% !important;
          max-height: 100% !important;
          box-sizing: border-box;
          padding-top: max(16px, env(safe-area-inset-top));
          padding-bottom: max(16px, env(safe-area-inset-bottom));
          overflow-x: hidden;
          overflow-y: auto;
          overscroll-behavior-y: contain;
          -webkit-overflow-scrolling: touch;
        }
        html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-header {
          flex-shrink: 0;
        }
        html.tdt-overlay-locked #CartDrawer {
          top: var(--tdt-overlay-top, 0px) !important;
          bottom: auto !important;
          height: var(--tdt-overlay-height, 100dvh) !important;
          max-height: var(--tdt-overlay-height, 100dvh) !important;
        }
      }
    `;
    document.head.appendChild(style);

    function save(el, names) {
      return names.map(function (name) {
        return [name, el.style.getPropertyValue(name), el.style.getPropertyPriority(name)];
      });
    }
    function restore(el, props) {
      props.forEach(function (prop) {
        if (prop[1]) el.style.setProperty(prop[0], prop[1], prop[2]);
        else el.style.removeProperty(prop[0]);
      });
    }
    function viewport() {
      if (!state) return;
      var vv = window.visualViewport;
      // Leave browser pinch zoom alone; Vivenu handles zoom inside its own iframe.
      if (vv && Math.abs(vv.scale - 1) > 0.02) return;
      var top = Math.max(0, Math.round(vv ? vv.offsetTop : 0));
      var height = Math.max(1, Math.floor(vv ? vv.height : window.innerHeight));
      var width = Math.round(window.innerWidth);
      function setSize(name, value) {
        var px = value + 'px';
        if (root.style.getPropertyValue(name) !== px) root.style.setProperty(name, px);
      }
      setSize('--tdt-overlay-top', top);
      setSize('--tdt-overlay-height', height);
      // Reserve the small viewport once per opening/width; toolbar expansion
      // moves the panel without repeatedly resizing Vivenu's canvas.
      if (!seatHeight || seatWidth !== width) {
        var small = Math.floor(smallViewport.getBoundingClientRect().height);
        seatHeight = Math.min(height, small > 0 ? small : height);
        seatWidth = width;
      }
      seatHeight = Math.min(seatHeight, height);
      setSize('--tdt-seat-height', seatHeight);
      setSize('--tdt-seat-top', top + height - seatHeight);
    }
    function lock() {
      if (state) return;
      var gap = Math.max(0, window.innerWidth - root.clientWidth);
      state = {
        x: window.scrollX, y: window.scrollY,
        body: save(body, ['position', 'top', 'left', 'width', 'overflow', 'padding-right']),
        root: save(root, ['overflow', 'scroll-behavior', '--tdt-overlay-top', '--tdt-overlay-height', '--tdt-seat-top', '--tdt-seat-height'])
      };
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      root.style.setProperty('overflow', 'hidden', 'important');
      if (gap) body.style.setProperty('padding-right', (parseFloat(getComputedStyle(body).paddingRight) + gap) + 'px', 'important');
      body.style.setProperty('position', 'fixed', 'important');
      body.style.setProperty('top', -state.y + 'px', 'important');
      body.style.setProperty('left', -state.x + 'px', 'important');
      body.style.setProperty('width', '100%', 'important');
      body.style.setProperty('overflow', 'hidden', 'important');
      root.classList.add('tdt-overlay-locked');
      viewport();
    }
    function unlock() {
      if (!state || document.querySelector(selector)) return;
      var previous = state;
      state = null;
      seatHeight = 0; seatWidth = 0;
      restore(body, previous.body);
      root.classList.remove('tdt-overlay-locked');
      // Keep restoration immediate even when the theme uses smooth anchor scrolling.
      restore(root, previous.root.filter(function (prop) { return prop[0] !== 'scroll-behavior'; }));
      window.scrollTo(previous.x, previous.y);
      restore(root, previous.root.filter(function (prop) { return prop[0] === 'scroll-behavior'; }));
    }
    function sync() {
      if (document.querySelector(selector)) {
        clearTimeout(closeTimer);
        closeTimer = 0;
        lock();
      } else if (state && !closeTimer) {
        // Keep one lock across Vivenu's handoff to the cart drawer.
        closeTimer = window.setTimeout(function () { closeTimer = 0; unlock(); }, 80);
      }
    }
    function scheduleViewport() {
      if (!state || frame) return;
      frame = requestAnimationFrame(function () { frame = 0; viewport(); });
    }
    var watched = new WeakSet();
    var states = new MutationObserver(sync);
    function watchOverlays() {
      document.querySelectorAll('.seating-app-smmodal, #CartDrawer').forEach(function (el) {
        if (watched.has(el)) return;
        watched.add(el);
        states.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
      sync();
    }
    var added = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return [...record.addedNodes, ...record.removedNodes].some(function (node) {
          return node.nodeType === 1 && (node.matches('.seating-app-smmodal, #CartDrawer') || node.querySelector('.seating-app-smmodal, #CartDrawer'));
        });
      })) watchOverlays();
    });
    added.observe(body, { childList: true, subtree: true });
    watchOverlays();
    window.addEventListener('resize', scheduleViewport, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleViewport, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleViewport, { passive: true });
    }
    // Stop gestures on the backdrop, but allow scrolling and pinch zoom inside overlays.
    document.addEventListener('touchmove', function (event) {
      if (state && event.cancelable && !event.target.closest(selector)) event.preventDefault();
    }, { passive: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOverlayViewport, { once: true });
  else initOverlayViewport();
})();

/* Ticket prices in the Vivenu CTA; discount rules verified 2026-09-17. */
(function () {
  'use strict';
  function quote(config, cart, selected, dealPage, hardticket) {
    if (!cart || cart.currency !== 'EUR' || !Array.isArray(selected)) return null;
    const allocations = (cart.cart_level_discount_applications || []).map(d => ({title:d.title, type:d.type, amount:d.total_allocated_amount}));
    (cart.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(a => allocations.push({title:a.discount_application.title, type:a.discount_application.type, amount:a.amount})));
    const codes = (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code.toLowerCase());
    allocations.forEach(d => { if (d.amount > 0) codes.push(String(d.title).toLowerCase()); });
    if (codes.some(c => c !== 'aktion20' && c !== 'aktion40')) return null;
    const mode = dealPage || codes.includes('aktion40') ? 'aktion40' : 'aktion20';
    let count = 0, gross = 0, saving = 0;
    for (const seat of selected) {
      const variant = config.variants.find(v => String(v.id) === String(seat.variantId));
      const quantity = seat.seatingInfo && seat.seatingInfo._type == 7 ? Number(seat.amount) : 1;
      if (!variant || !Number.isSafeInteger(quantity) || quantity < 1 || seat.ticketFeeId) return null;
      count += quantity;
      gross += variant.price * quantity;
    }
    const used20 = allocations.filter(d => String(d.title).toLowerCase() === 'aktion20').reduce((sum,d) => sum + Number(d.amount || 0), 0);
    if (mode === 'aktion20' && config.eligible20) {
      if ((cart.items || []).length && used20 === 0) return null;
      saving = Math.min(gross, Math.max(0, 2000 - used20));
    }
    if (hardticket) {
      if (!Number.isSafeInteger(config.hardticketPrice) || config.hardticketPrice < 0) return null;
      gross += config.hardticketPrice * count;
    }
    // Vivenu creates one eligible parent bundle, including the optional Fanticket.
    // Shopify truncates the percentage discount to whole cents on that bundle.
    if (mode === 'aktion40' && config.eligible40) saving = Math.floor(gross * 40 / 100);
    return {count, gross, saving, net:gross-saving, mode, used20, hardticket};
  }
  const configNode = document.getElementById('tdt-seat-price-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const modal = document.querySelector('[data-smmodal-id="'+config.productId+'"]');
  const button = modal && modal.querySelector('[data-smmodal-submit]');
  if (!button) return;
  const style = document.createElement('style');
  style.textContent = '.seating-app-smmodal .discount-info{display:none!important}.tdt-seat-price-detail{margin:7px 0 0!important;text-align:center;font:14px/1.35 Arial,sans-serif!important;color:#425466;letter-spacing:normal;min-height:2.7em;flex-shrink:0}.tdt-seat-price-detail:empty{display:block;visibility:hidden}.seating-app-smmodal .smmodal-atc{display:flex;align-items:center;justify-content:center;gap:9px;white-space:normal;letter-spacing:normal!important;font-size:18px!important;line-height:1.3!important}.seating-app-smmodal .smmodal-atc svg{flex-shrink:0}.seating-app-smmodal .smmodal-atc span{min-width:0}';
  style.textContent += ".seating-app-smmodal .smmodal-atc{height:80px!important;min-height:80px!important;box-sizing:border-box;padding:10px 12px!important;text-transform:none!important;background:#173451!important;color:#fff!important;border-color:#173451!important}.seating-app-smmodal .smmodal-atc:disabled{background:#e4e8ec!important;color:#657381!important;border-color:#e4e8ec!important;opacity:1!important}.seating-app-smmodal .smmodal-atc>svg{display:none!important}.seating-app-smmodal .smmodal-atc>span{display:flex;flex-direction:column;align-items:center;gap:3px}.seating-app-smmodal .tdt-seat-action{display:flex;align-items:center;justify-content:center;gap:8px;font:700 20px/1.3 Arial,sans-serif;white-space:nowrap}.seating-app-smmodal .tdt-seat-action svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:2}.seating-app-smmodal .tdt-seat-summary{display:block;min-height:20px;font:400 15px/20px Arial,sans-serif}.seating-app-smmodal .smmodal-atc:focus-visible{outline:3px solid #b99b60;outline-offset:3px}@media(max-width:360px){.seating-app-smmodal .tdt-seat-action{font-size:18px}}";
  style.textContent += ".seating-app-smmodal .grid-item__footer .tips{margin:0!important;padding:0!important}.seating-app-smmodal .grid-item__footer .tips p{margin:0!important;font:16px/22px Arial,sans-serif}.seating-app-smmodal .smmodal-atc{height:64px!important;min-height:64px!important;padding:6px 10px!important}.seating-app-smmodal .tdt-seat-price-detail{width:100%;margin:2px 0 0!important;font-size:12px!important;line-height:16px!important;min-height:32px}.seating-app-smmodal .grid-item__footer{gap:4px!important}@media(max-width:769px){html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-content{padding-top:max(8px,env(safe-area-inset-top));padding-bottom:max(8px,env(safe-area-inset-bottom));overflow:hidden!important}html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-body{flex:1 1 0!important;min-height:0!important;height:auto!important}html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-body>.grid{height:100%!important;min-height:0!important;grid-template-rows:minmax(0,1fr) auto!important;gap:8px!important}html.tdt-overlay-locked .seating-app-smmodal.active .smmodal-body>.grid>.grid-item:first-child{height:100%!important;min-height:0!important;}html.tdt-overlay-locked .seating-app-smmodal.active #map,html.tdt-overlay-locked .seating-app-smmodal.active #map iframe{height:100%!important;min-height:0!important;max-height:100%!important}html.tdt-overlay-locked .seating-app-smmodal.active .flex__footer{height:auto!important;min-height:0!important;max-height:min(260px,calc(var(--tdt-overlay-height,100dvh)*0.55));overflow-y:auto;overscroll-behavior:contain}html.tdt-overlay-locked .seating-app-smmodal.active .grid-item__footer{flex-shrink:0!important;padding:4px!important}.seating-app-smmodal .hardticket-wrapper{min-height:28px}.seating-app-smmodal .hardticket-wrapper label{font-size:13px!important}}";
  style.textContent += `.seating-app-smmodal .tdt-seat-options{display:contents}
.seating-app-smmodal .tdt-seat-price-detail{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:1px;padding:3px 6px!important;box-sizing:border-box;border-radius:5px;background:#d6f1df;color:#135d36!important;font:700 14px/18px Arial,sans-serif!important;min-height:44px!important}
.seating-app-smmodal .tdt-seat-price-detail:empty{visibility:hidden}
.seating-app-smmodal .tdt-seat-price-detail small{font:400 12px/16px Arial,sans-serif;color:#355747}
@media(max-width:769px){
html.tdt-overlay-locked .seating-app-smmodal.active .flex__footer{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;flex:0 0 auto!important}
html.tdt-overlay-locked .seating-app-smmodal.active .grid-item__footer{display:grid!important;grid-template-columns:minmax(0,1fr)!important;justify-content:stretch!important;align-items:stretch!important;grid-template-rows:auto 64px 44px!important;height:auto!important;min-height:0!important;width:100%;box-sizing:border-box;overflow:visible!important;gap:5px!important}
html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-options{display:flex;flex-direction:column;gap:4px;min-height:0;height:auto;overflow:visible!important}
html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-options>*{flex-shrink:0}
html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-price-detail{height:44px!important;min-height:44px!important;max-height:none!important;overflow:visible!important;margin:0!important}
html.tdt-overlay-locked .seating-app-smmodal.active .hardticket-wrapper{margin:0!important;min-height:32px!important;gap:6px!important;justify-content:center!important;align-items:center!important}
html.tdt-overlay-locked .seating-app-smmodal.active .hardticket-wrapper input{flex:0 0 18px;width:18px;height:18px;margin:0!important}
html.tdt-overlay-locked .seating-app-smmodal.active .hardticket-wrapper label{font:700 13px/18px Arial,sans-serif!important;margin:0!important;white-space:normal!important}
html.tdt-overlay-locked .seating-app-smmodal.active .info-icon-wrapper{flex:0 0 24px}
html.tdt-overlay-locked .seating-app-smmodal.active [data-smmodal-invalid-selection]{margin:0!important;font:13px/18px Arial,sans-serif!important}
}`;
  style.textContent += "@media(max-width:769px){html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-options .info-popup{position:fixed!important;top:calc(var(--tdt-seat-top,0px) + 90px)!important;bottom:auto!important;left:50%!important;right:auto!important;transform:translateX(-50%)!important;width:min(300px,calc(100vw - 40px))!important;max-height:calc(var(--tdt-seat-height,100svh) - 290px)!important;overflow-y:auto!important;overscroll-behavior:contain;z-index:10}html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-options .info-popup>*{flex-shrink:0}html.tdt-overlay-locked .seating-app-smmodal.active .tdt-seat-options .info-popup-close{position:sticky!important;top:0!important;align-self:flex-end}}";
  style.textContent += "@media(max-width:769px){html.tdt-overlay-locked .seating-app-smmodal.active::before{content:\"\";position:fixed;inset:0;background:#fff;z-index:100;pointer-events:auto}html.tdt-overlay-locked .seating-app-smmodal.active .hardticket-wrapper{justify-content:center!important;align-items:center!important;width:100%}html.tdt-overlay-locked .seating-app-smmodal.active #map{overflow:hidden!important}html.tdt-overlay-locked .seating-app-smmodal.active #map::after{pointer-events:none!important}}";
  const tips = modal.querySelector('.grid-item__footer .tips');
  if (tips) {
    const lines = tips.querySelectorAll('p');
    if (lines[0]) lines[0].textContent = 'Zoomen & farbigen Platz wählen';
    if (lines[1] && /2\.\s*(?:Button klicken|Click the button)/i.test(lines[1].textContent)) lines[1].remove();
  }
  document.head.appendChild(style);
  const detail = document.createElement('p');
  detail.className = 'tdt-seat-price-detail';
  detail.setAttribute('aria-live','polite');
  button.insertAdjacentElement('afterend',detail);
  // Keep the original controls/listeners. Options take their full height; only the map pans.
  const footer = button.parentElement;
  const options = document.createElement('div');
  options.className = 'tdt-seat-options';
  while (footer.firstChild && footer.firstChild !== button) options.appendChild(footer.firstChild);
  footer.insertBefore(options, button);
  const invalid = options.querySelector('[data-smmodal-invalid-selection]');
  if (invalid) {
    options.insertBefore(invalid, options.firstChild);
    new MutationObserver(() => {
      if (!invalid.classList.contains('sm-hidden') && !invalid.hidden) options.scrollTop = 0;
    }).observe(invalid, {attributes:true, attributeFilter:['class','hidden']});
  }
  let cart = null, pending = null, frame = 0;
  const money = n => new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(n / 100);
  function render() {
    frame = 0;
    const selected = window.vivenu && window.vivenu.reservation && window.vivenu.reservation.selectedObjects;
    if (!Array.isArray(selected)) return;
    const hardticket = Boolean(modal.querySelector('[name="hardticket"]:checked'));
    const hasUpsell = Boolean(modal.querySelector('[name^="ticket-upsell"]:checked'));
    const dealPage = Boolean(document.querySelector('[data-tdt-deal-code="aktion40"]'));
    const result = hasUpsell ? null : quote(config,cart,selected,dealPage,hardticket);
    const count = selected.reduce((n,s) => n + (s.seatingInfo && s.seatingInfo._type == 7 ? Number(s.amount)||0 : 1),0);
    let label = count ? count+' '+(count===1?'Ticket':'Tickets') : 'Bitte Sitzplätze wählen';
    let note = '', previous = '', extra = '';
    if (result && count) {
      label = result.count+' '+(result.count===1?'Ticket':'Tickets')+' · '+money(result.net);
      if (result.saving) {
        note = 'Du sparst '+money(result.saving)+(result.mode==='aktion40'?' · 40 %':'');
        previous = money(result.gross);
      } else if (result.mode==='aktion20' && result.used20) {
        note = money(result.used20)+' Bestellvorteil';
        extra = 'bereits im Warenkorb';
      }
      if (hardticket) extra += (extra?' · ':'')+'inkl. Fanticket';
    }
    let span = button.querySelector('span');
    if (span) {
      let action = span.querySelector('.tdt-seat-action');
      let summary = span.querySelector('.tdt-seat-summary');
      if (!action || !summary) {
        span.innerHTML = '<strong class="tdt-seat-action"><span></span><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 12h15M13 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg></strong><small class="tdt-seat-summary"></small>';
        action = span.querySelector('.tdt-seat-action');
        summary = span.querySelector('.tdt-seat-summary');
      }
      const actionLabel = count ? 'Weiter zum Warenkorb' : 'Bitte Sitzplätze wählen';
      const actionText = action.querySelector('span');
      if (actionText.textContent !== actionLabel) actionText.textContent = actionLabel;
      if (summary.textContent !== label) summary.textContent = label;
      summary.style.visibility = count ? 'visible' : 'hidden';
      action.querySelector('svg').style.display = count ? '' : 'none';
    }
    const benefitKey = [note, previous, extra].join('|');
    if (detail.dataset.benefitKey !== benefitKey) {
      detail.dataset.benefitKey = benefitKey;
      detail.replaceChildren();
      if (note) {
        const savingLine = document.createElement('strong');
        savingLine.textContent = note;
        detail.appendChild(savingLine);
      }
      if (previous || extra) {
        const meta = document.createElement('small');
        if (previous) {
          meta.appendChild(document.createTextNode('statt '));
          const strike = document.createElement('s');
          strike.textContent = previous;
          meta.appendChild(strike);
        }
        if (extra) meta.appendChild(document.createTextNode((previous ? ' · ' : '') + extra));
        detail.appendChild(meta);
      }
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  function refresh() {
    if (pending) return pending;
    cart = null;
    schedule();
    const read = window.tdtReadTicketBenefit || (() => fetch((window.Shopify.routes.root || '/')+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); }));
    pending = read().then(value => { cart = value; }).catch(() => {cart=null;}).finally(() => {pending=null;schedule();});
    return pending;
  }
  new MutationObserver(schedule).observe(modal,{childList:true,subtree:true,characterData:true});
  let wasOpen = modal.classList.contains('active');
  new MutationObserver(() => { const open = modal.classList.contains('active'); if (open && !wasOpen) refresh(); wasOpen = open; }).observe(modal,{attributes:true,attributeFilter:['class']});
  modal.addEventListener('change',schedule);
  window.addEventListener('focus',refresh);
  window.addEventListener('cart:open',refresh);
  document.addEventListener('cart:updated',refresh);
  refresh();
})();

